import styled, { css } from 'styled-components';
import { StyledBarChartProps, StyledBarChartSectionProps, StyledBarChartBarsProps } from './types';
import { ChartContainer } from '../ChartContainer';
import { Theme } from '@redsift/design-system';

/**
 * Component style.
 */
export const StyledBarChart = styled(ChartContainer)<StyledBarChartProps>``;

export const StyledBarChartSection = styled.g<StyledBarChartSectionProps>`
  text.colored {
    ${({ $textColor }) => css`
      fill: ${$textColor};
    `}
  }

  .title {
    font-size: 16px;
    font-weight: 600;
  }
`;

export const StyledBarChartBars = styled.g<StyledBarChartBarsProps>``;

export const StyledBarChartOverlay = styled.g<StyledBarChartBarsProps>`
  .redsift-overlay-bar:hover rect {
    fill: rgba(0, 0, 0, 0.1);
  }
`;

export const StyledBarChartEmptyText = styled.div<{
  $maxWidth: number;
  $textSize: number;
  $theme: Theme;
}>`
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  pointer-events: none;

  > * {
    max-width: ${({ $maxWidth }) => $maxWidth}px;
  }

  > span {
    font-family: var(--redsift-typography-font-family-poppins);
    color: ${({ $theme }) => `var(--redsift-color-${$theme}-components-text-primary)`};
    font-size: ${({ $textSize }) => $textSize}px;
    line-height: ${({ $textSize }) => $textSize}px;
  }
`;
